import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconUserGroup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUserGroup"><Circle cx="12" cy="8.75" r="3.25" stroke="currentColor"/><Circle cx="4" cy="9.82996" r="2" stroke="currentColor"/><Circle cx="20" cy="9.82996" r="2" stroke="currentColor"/><Path d="M6.5 18.5V17.5C6.5 14.4624 8.96243 12 12 12C15.0376 12 17.5 14.4624 17.5 17.5V18.5H6.5Z" stroke="currentColor"/><Path d="M5 17.5H0.5C0.5 14.5 1.5 12.5 4 11.8301" stroke="currentColor"/><Path d="M19 17.5H23.5C23.5 14.5 22.5 12.5 20 11.8301" stroke="currentColor"/></CentralIconBase>;
});

export default IconUserGroup;
